import Link from "next/link";
import { Heading, Stack, Text } from "@chakra-ui/react";
import { HEADING_VARIANTS } from "@/theme/components/heading";
import {
  FOOTER_CONSTANTS,
  CLOUD_SERVERS_POLICY,
  COLOCATION_POLICY,
} from "../footer.constants";

const FooterServersPolicies = () => {
  return (
    <Stack spacing={6} color="white">
      <Heading variant={HEADING_VARIANTS.SUBTITLE2}>
        {FOOTER_CONSTANTS.CLOUD_SERVERS_POLICY}
      </Heading>
      <Stack spacing={"0.6rem"}>
        {CLOUD_SERVERS_POLICY.map((service) => (
          <Link href={service.path} key={service.path}>
            <Text _hover={{ textDecor: "underline" }} lineHeight={1.3}>
              {service.name}
            </Text>
          </Link>
        ))}
      </Stack>
      <Heading variant={HEADING_VARIANTS.SUBTITLE2}>
        {FOOTER_CONSTANTS.COLOCATION_POLICY}
      </Heading>
      <Stack spacing={"0.6rem"}>
        {COLOCATION_POLICY.map((service) => (
          <Link href={service.path} key={service.path}>
            <Text _hover={{ textDecor: "underline" }} lineHeight={1.3}>
              {service.name}
            </Text>
          </Link>
        ))}
      </Stack>
    </Stack>
  );
};

export default FooterServersPolicies;
